var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commerce__productos"},[_c('ProductsCarousel',{attrs:{"products":_vm.getProducts,"title":_vm.category.name,"route":_vm.getRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }